import { init as initModals } from './modals'
import { init as initLargeLinks } from './largeLinks'

const init = () => {
  initModals()
  initLargeLinks()
}

export default init



//////////////////
// WEBPACK FOOTER
// ./src/js/sb/index.js
// module id = 8
// module chunks = 0